export enum AppRoute {
  Home = "/",
  FooterImpressum = '/impressum',
  FooterTOS = '/nutzungsbedingungen',
  FooterDataProtection = '/datenschutz',
  Tutorspace = "https://tutorspace.de/",
}
